var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35Z",
    fill: "#81061A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.75 20.25H54.76V48.98H51.27V42.9C51.27 41.34 51.29 41.03 49.8 40.34V37.26H44.74V20.25H44.75ZM15.28 19.18V21.05H15.54V19.18H15.28ZM15.79 19.18V21.05H16.05V19.18H15.79ZM16.31 19.18V21.05H16.57V19.18H16.31ZM16.82 19.18V21.05H17.08V19.18H16.82ZM17.33 19.18V21.05H17.59V19.18H17.33ZM17.85 19.18V21.05H18.11V19.18H17.85ZM18.36 19.18V21.05H18.62V19.18H18.36ZM18.88 19.18V21.05H19.14V19.18H18.88ZM19.39 19.18V21.05H19.65V19.18H19.39ZM19.91 19.18V21.05H20.17V19.18H19.91ZM20.42 19.18V21.05H20.68V19.18H20.42ZM20.93 19.18V21.05H21.19V19.18H20.93ZM21.45 19.18V21.05H21.71V19.18H21.45ZM21.96 19.18V21.05H22.22V19.18H21.96ZM22.48 19.18V21.05H22.74V19.18H22.48ZM22.99 19.18V21.05H23.25V19.18H22.99ZM23.51 19.18V21.05H23.77V19.18H23.51ZM24.02 19.18V21.05H24.28V19.18H24.02ZM24.53 19.18V21.05H24.79V19.18H24.53ZM25.05 19.18V21.05H25.31V19.18H25.05ZM25.56 19.18V21.05H25.82V19.18H25.56ZM20.56 22.59C22.22 22.59 23.56 23.93 23.56 25.59C23.56 27.25 22.22 28.59 20.56 28.59C18.9 28.59 17.56 27.25 17.56 25.59C17.56 23.93 18.9 22.59 20.56 22.59ZM15 21.05H15.03V19.18V19.16V19H26.08V19.16V19.18V21.05H26.12L25.82 26.67C24.9 27.49 24.32 28.49 24.32 29.81V45.3H16.26L15 21.05ZM16.25 45.98H24.33V49.96H16.89C16.54 49.96 16.26 49.68 16.26 49.33V45.98H16.25ZM29.36 26.06H36.41C38.72 26.06 40.61 27.96 40.61 30.26V37.26H37.66V31.67H28.09V46.74L33.9 46.93V50.04L25.14 49.85V30.25C25.15 27.95 27.04 26.06 29.36 26.06ZM30.02 24.56H35.75V25.67H30.02V24.56ZM31.33 24.18H34.44V21.79H31.33V24.18ZM30.05 19.04L41.01 19.82V21.21H30.05V19.04ZM36.41 38.22H48.59V40.33H36.41V38.22ZM37.27 40.94H47.3C49.61 40.94 50.24 41.53 50.24 42.25V51.21H34.78V42.25C34.77 41.53 34.95 40.94 37.27 40.94ZM37.72 50.24H47.29V42.68H37.72V50.24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelling);
export default __webpack_public_path__ + "static/media/labelling.90b5893e8ecd35c7be637c0607d27b8f.svg";
export { ForwardRef as ReactComponent };